function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "52",
  height: "110",
  viewBox: "0 0 52 110",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.68 57.829c-5.842-5.392-9.478-12.348-10.109-17.12-.08-.612-.373-.74-.685-.74-.312 0-.604.128-.684.74-.632 4.772-4.267 11.728-10.11 17.12C11.281 61.345 0 70.139 0 84.165c0 14.16 12.106 25.47 25.885 25.47 13.779 0 25.888-11.31 25.888-25.47 0-14.025-11.281-22.82-15.092-26.336"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.627 30.04c3.389 3.127 5.496 7.16 5.862 9.927.047.355.216.43.397.43.181 0 .35-.075.397-.43.366-2.766 2.474-6.8 5.862-9.927 2.21-2.039 8.752-7.138 8.752-15.27 0-8.211-7.02-14.77-15.01-14.77S10.876 6.559 10.876 14.77c0 8.132 6.541 13.231 8.751 15.27"
}))));